
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import WeException from "@/components/We/exception.vue";

@Component({
    name: "CustomDialog", // 改为唯一名称
    components: {
        WeException,
    },
})
export default class CustomDialog extends Vue {
    @Prop({ default: "" }) private title!: string; // 弹窗标题
    @Prop({ default: "" }) private title2!: string; // 弹窗标题
    @Prop({ default: "2000" }) private zIndex!: number; // 弹窗层级
    @Prop({ default: true }) private showBtn!: boolean; // 显示按钮
    @Prop({ default: false }) private disabled!: boolean; // 显示按钮
    @Prop({default:0}) private badge!:number;//徽标
    @Prop({default:'45%'}) private minWidth!:string;//最小宽度

    private show: boolean = false;
    private type: number = 1; // 1 代表没有loading开启  2 代表有loading开启
    private load: any = {
        code: 100,
        msg: "加载中",
    };
    private animateLoad: boolean = false;
    private animate: boolean = false;
    private isBtnLoad: boolean = false;
    private titleShow: string = "";
    @Watch("title")
    onTitleChange(val: string) {
        if (this.show) {
            this.titleShow = val;
        }
    }

    private created() {
        document.onkeydown = (e) => {
            if (e.which == 27) {
                this.close();
            }
        };
    }

    close() {
        this.animate = false;
        this.animateLoad = false;
        document.body.style.overflow = "auto";
        this.show = false;
        this.$emit("close");
    }

    open(val: any = { type: 1 }) {
        this.show = true;
        this.type = val.type;
        if(this.title2 && this.title2 != "") {
            this.titleShow = this.title2;
        }
        else{
            this.titleShow = this.title;
        }
        if (val.type == 2) {
            this.load = {
                code: 100,
                msg: "加载中",
            };

            setTimeout(() => {
                this.animateLoad = true;
            }, 20);
        } else {
            this.load = {
                code: 1000,
            };
            setTimeout(() => {
                this.animate = true;
            }, 20);
        }

        document.body.style.overflow = "hidden";
    }

    showLoad() {
        if (this.show) {
            this.load = {
                code: 100,
                msg: "加载中",
            };
        }
    }

    hideLoad(val: { code: number; msg?: string }) {
        this.load = {
            code: val.code,
            msg: val.msg,
        };
    }

    submit() {
        this.$emit("parentEvent");
    }
}
